import React, { useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ModalContext } from '~/contexts';
import { BODY_ID } from '~/utils';
import { Wrapper } from './styles';

const Modal: React.FC = ({ children }) => {
  const { visibility } = useContext(ModalContext);

  const PortalElement = createPortal(
    <Wrapper>{children}</Wrapper>,
    document.body,
  );

  useEffect(() => {
    const body = window.document.getElementById(BODY_ID);

    if (visibility) {
      if (body) body.style.overflow = 'hidden';
      return;
    }
    if (body) body.style.overflow = 'auto';
  }, [visibility]);

  return visibility ? PortalElement : null;
};

export default Modal;
